@if (pageInfo$ | async; as pageInfo) {
  <app-pagination-buttons
    [totalPages]="pageInfo.totalPages"
    [currentPageIndex]="pageInfo.currentPageIndex"
    [visibleButtonsCount]="9"
    (selectPage)="selectPage($event)"
  ></app-pagination-buttons>
}
